import { Link } from 'react-router';
import { t } from '../i18n';
import { useAuth, useMe } from '../lib/auth';
import { usePopover } from './usePopover';

/** Menú de la persona (avatar con iniciales): su correo, su seguridad y cerrar sesión. `dark` para fondos oscuros. */
export function UserMenu({ dark = false }: { dark?: boolean }) {
  const me = useMe();
  const { logout } = useAuth();
  const menu = usePopover();
  return (
    <div className="relative" ref={menu.ref}>
      <button
        type="button"
        className={`flex items-center gap-2 rounded px-2 py-1 text-sm focus:outline-none focus-visible:ring-2 ${
          dark ? 'text-white/85 hover:bg-white/10 focus-visible:ring-senal' : 'text-slate-700 hover:bg-slate-100 focus-visible:ring-marca/40'
        }`}
        aria-haspopup="menu"
        aria-expanded={menu.open}
        onClick={menu.toggle}
      >
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-marca-suave text-xs font-semibold text-marca-claro" aria-hidden>
          {initials(me.fullName)}
        </span>
        <span className="hidden sm:inline">{me.fullName}</span>
      </button>
      {menu.open && (
        <div role="menu" className="absolute right-0 z-20 mt-1 w-52 rounded-md border border-slate-200 bg-white py-1 text-slate-800 shadow-lg">
          <p className="border-b border-slate-100 px-3 pb-2 pt-1.5 text-xs text-slate-500">{me.email}</p>
          <Link role="menuitem" to="/perfil/seguridad" className="block px-3 py-2 text-sm hover:bg-slate-50" onClick={() => menu.setOpen(false)}>
            {t('menu.mi_seguridad')}
          </Link>
          <button role="menuitem" type="button" className="block w-full px-3 py-2 text-left text-sm hover:bg-slate-50" onClick={() => void logout()}>
            {t('menu.cerrar_sesion')}
          </button>
        </div>
      )}
    </div>
  );
}

/** Iniciales para el avatar (dos como máximo). */
function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '')).toUpperCase();
}
